import React from 'react'
import { Button, DropdownButton, MenuItem } from 'react-bootstrap'
import { List } from 'immutable'
import Icon from '_/shared/components/icon'
import PinModal from '_/shared/components/pinModal'
import TopTooltip from '_/shared/components/topTooltip'
import EmailRecordModal from '_/shared/components/emailRecordModal'
import FlagRecordModal from '_/shared/components/flagRecordModal'

import getTransactionName from '_/utils/getTransactionName'

/**
 * Transaction page actions
 */
class TransactionActions extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    property: React.PropTypes.object.isRequired,
    transaction: React.PropTypes.object.isRequired,
    handleEdit: React.PropTypes.func,
    hasCopy: React.PropTypes.bool,
    type: React.PropTypes.string,
    editing: React.PropTypes.bool,
    isNew: React.PropTypes.bool
  }

  static contextTypes = {
    router: React.PropTypes.func
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      isPinOpen: false
    }
  }

  showPinModal () {
    this.setState({
      isPinOpen: true
    })
  }

  hidePinModal () {
    this.setState({
      isPinOpen: false
    })
  }

  handleCopy () {
    const { property, transaction } = this.props
    const { router } = this.context

    router.transitionTo('lease', {
      id: property.get('id'),
      transId: 'new'
    }, {
      transaction: transaction.get('id')
    })
  }

  render() {
    const { account, property, transaction, editing, type, isNew, handleEdit, hasCopy } = this.props
    const { isPinOpen } = this.state

    if (isNew) return null

    const isPrivate = transaction.get('isPrivate')
    const isAdmin = account.get('isAdmin')
    const isAg = account.getIn(['group', 'isAg'])
    const canPin = isPrivate || (!isPrivate && !isAdmin)

    const bsStyle = 'link'
    const bsSize = 'small'

    return (
      <div className="redi-component-actions-bar">
        <Button
          active={editing}
          className="hotkeys-edit"
          bsStyle={editing ? 'warning' : bsStyle}
          bsSize={bsSize}
          onClick={handleEdit}>
          {editing ? 'Editing...' : 'Edit'}
        </Button>

        {hasCopy &&
          <Button
            onClick={::this.handleCopy}
            bsStyle={bsStyle}
            bsSize={bsSize}>
            Copy
          </Button>
        }

        <DropdownButton
          pullRight
          id={`${type}-reports-id`}
          bsStyle={bsStyle}
          bsSize={bsSize}
          title="Reports">
          {!isAg &&
            <MenuItem
              href={`/${type}s/${transaction.get('id')}/summary?useLayout=true`}
              target="_blank"
              key={0}>
              Summary {getTransactionName(type).toLowerCase()} report w/exhibits
            </MenuItem>
          }
          <MenuItem
            href={`/${type}s/${transaction.get('id')}/detail?useLayout=true`}
            target="_blank"
            key={1}>
            Detailed {getTransactionName(type).toLowerCase()} report w/exhbits
          </MenuItem>
          {!isAg &&
            <MenuItem
              href={`/${type}s/${transaction.get('id')}/report`}
              target="_blank"
              key={2}>
              Customizable {getTransactionName(type).toLowerCase()} report
            </MenuItem>
          }
          {type === 'sale' &&
            <MenuItem
              href={`/sales/${transaction.get('id')}/writeup-report`}
              target="_blank"
              key={3}
            >
              Writeup report
            </MenuItem>
          }
          {transaction.has('rediNo') &&
            <MenuItem
              href={`http://adn.redi-net.com/report/master/${transaction.get('rediNo')}`}
              target="_blank"
              key={3}>
              ADN
            </MenuItem>
          }
        </DropdownButton>

        {isAdmin && !isPrivate &&
          <Button
            href={`/${type}s/${transaction.get('id')}/inspection`}
            bsStyle={bsStyle}
            bsSize={bsSize}>
            Inspection
          </Button>
        }

        {canPin &&
          <TopTooltip content="Pin to project">
            <Button bsStyle="link" onClick={::this.showPinModal}>
              <Icon name ="fa-thumb-tack" />
            </Button>
          </TopTooltip>
        }

        {isPrivate &&
          <EmailRecordModal
            recordId={property.get('id')}
          />
        }

        {!isPrivate && !isAdmin &&
          <FlagRecordModal
            recordId={property.get('id')}
          />
        }

        <PinModal
          open={isPinOpen}
          onClose={::this.hidePinModal}
          transactionIds={List([ transaction.get('id') ])}
          title="Add this transaction to project(s)"
          type={type} />
      </div>
    )
  }
}

export default TransactionActions



// WEBPACK FOOTER //
// ./modules/shared/pages/record/transactionActions.js